/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VacancyKpiReportControllerGetVacanciesReport200ResponseDataWeeklySummary } from './vacancyKpiReportControllerGetVacanciesReport200ResponseDataWeeklySummary';
import { VacancyKpiReportControllerGetVacanciesReport200ResponseDataRotationSummary } from './vacancyKpiReportControllerGetVacanciesReport200ResponseDataRotationSummary';
import { VacancyKpiReportControllerGetVacanciesReport200ResponseDataVacanciesSummary } from './vacancyKpiReportControllerGetVacanciesReport200ResponseDataVacanciesSummary';
import { VacancyKpiReportControllerGetVacanciesReport200ResponseDataDepartmentSummary } from './vacancyKpiReportControllerGetVacanciesReport200ResponseDataDepartmentSummary';


export interface VacancyKpiReportControllerGetVacanciesReport200ResponseData { 
    weeklySummary?: VacancyKpiReportControllerGetVacanciesReport200ResponseDataWeeklySummary;
    vacanciesSummary?: VacancyKpiReportControllerGetVacanciesReport200ResponseDataVacanciesSummary;
    departmentSummary?: VacancyKpiReportControllerGetVacanciesReport200ResponseDataDepartmentSummary;
    rotationSummary?: VacancyKpiReportControllerGetVacanciesReport200ResponseDataRotationSummary;
}

